<ng-select
        [items]="listValue$ | async"
        id="tag" 
        name="tag" 
        class="form-control"
        #field_value="ngModel"
        bindLabel="tag_name"
        bindValue="tag_name"
        placeholder="{{'tags.placeholder' | translate}}"
        appendTo="body"
        [addTag]="!options?.preventNewTag"
        addTagText="Add Tag"
        [multiple]="true"
        [hideSelected]="true"
        [loading]="lookupLoading"
        typeToSearchText="{{'info.type_to_search_text' | translate}}"
        [(ngModel)]="tags"
        (add)="addNewTag($event)"
        (change)="tagChanged()"
        [typeahead]="valueSubject$"
        >
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
                <span class="ng-value-label text-base">{{item.tag_name}}</span>
                <span class="ng-value-icon right text-base" (click)="clear(item)" aria-hidden="true">×</span>
        </ng-template>
</ng-select>